const conciseSize = (size) => {
  const extras = size.match(/([X])\1*/g);
  if (extras && extras[0].length >= 2) {
    return extras[0].length + size.substring(size.length - 2);
  }
  return size;
};

export default conciseSize;
